import { differenceInDays } from "date-fns";
import * as Yup from "yup";

export const archiveReportValidationSchema = (values) =>
  Yup.object().shape({
    reportStartDate: Yup.string()
      .nullable()
      .required("Report Start Date is required")
      .test(
        "is-before-end",
        "Report Start Date cannot be after Report End Date",
        function (reportStartDate) {
          const { reportEndDate } = this.parent;
          return reportEndDate
            ? new Date(reportStartDate) <= new Date(reportEndDate)
            : true;
        }
      )
      .test(
        "is-in-range",
        "Report Start Date should be within 1 year from Report End Date",
        function (reportStartDate) {
          const { reportEndDate } = this.parent;
          if (reportStartDate && reportEndDate) {
            const diffDays = differenceInDays(
              new Date(reportEndDate),
              new Date(reportStartDate)
            );
            return diffDays <= 365; // 1 year range
          }
          return true;
        }
      ),
    reportEndDate: Yup.string()
      .nullable()
      .required("Report End Date is required")
      .test(
        "is-after-start",
        "Report End Date cannot be before Report Start Date",
        function (reporEndDate) {
          const { reportStartDate } = this.parent;
          return reportStartDate
            ? new Date(reporEndDate) >= new Date(reportStartDate)
            : true;
        }
      )
      .test(
        "is-in-range",
        "Report End Date should be within 1 year from Report Start Date",
        function (reportEndDate) {
          const { reportStartDate } = this.parent;
          if (reportStartDate && reportEndDate) {
            const diffDays = differenceInDays(
              new Date(reportStartDate),
              new Date(reportEndDate)
            );
            return diffDays <= 365; // 1 year range
          }
          return true;
        }
      ),
    processedStartDate: Yup.string()
      .nullable()
      .test(
        "is-before-end",
        "Processed Start Date cannot be after Processed End Date",
        function (processedStartDate) {
          const { processedEndDate } = this.parent;
          return processedEndDate
            ? new Date(processedStartDate) <= new Date(processedEndDate)
            : true;
        }
      )
      .test(
        "is-in-range",
        "Processed Start Date should be within 1 year from Processed End Date",
        function (processedStartDate) {
          const { processedEndDate } = this.parent;
          if (processedStartDate && processedEndDate) {
            const diffDays = differenceInDays(
              new Date(processedEndDate),
              new Date(processedStartDate)
            );
            return diffDays <= 365; // 1 year range
          }
          return true;
        }
      ),
    processedEndDate: values?.processedStartDate
      ? Yup.string()
          .required("Processed End Date is required")
          .test(
            "is-after-start",
            "Processed End Date cannot be before Processed Start Date",
            function (processedEndDate) {
              const { processedStartDate } = this.parent;
              return processedStartDate
                ? new Date(processedEndDate) >= new Date(processedStartDate)
                : true;
            }
          )
          .test(
            "is-in-range",
            "Processed End Date should be within 1 year from Processed Start Date",
            function (processedEndDate) {
              const { processedStartDate } = this.parent;
              if (processedStartDate && processedEndDate) {
                const diffDays = differenceInDays(
                  new Date(processedStartDate),
                  new Date(processedEndDate)
                );
                return diffDays <= 365; // 1 year range
              }
              return true;
            }
          )
      : Yup.string().nullable(),

    lastBillingStartDate: Yup.string()
      .nullable()
      .test(
        "is-before-end",
        "Last Billing Start Date cannot be after Last Billing End Date",
        function (lastBillingStartDate) {
          const { lastBillingEndDate } = this.parent;
          return lastBillingEndDate
            ? new Date(lastBillingStartDate) <= new Date(lastBillingEndDate)
            : true;
        }
      )
      .test(
        "is-in-range",
        "Last Billing Start Date should be within 1 year from Last Billing End Date",
        function (lastBillingStartDate) {
          const { lastBillingEndDate } = this.parent;
          if (lastBillingStartDate && lastBillingEndDate) {
            const diffDays = differenceInDays(
              new Date(lastBillingEndDate),
              new Date(lastBillingStartDate)
            );
            return diffDays <= 365; // 1 year range
          }
          return true;
        }
      ),
    lastBillingEndDate: values?.lastBillingStartDate
      ? Yup.string()
          .required("Last Billing End Date is required")
          .test(
            "is-after-start",
            "Processed End Date cannot be before Processed Start Date",
            function (lastBillingEndDate) {
              const { lastBillingStartDate } = this.parent;
              return lastBillingStartDate
                ? new Date(lastBillingEndDate) >= new Date(lastBillingStartDate)
                : true;
            }
          )
          .test(
            "is-in-range",
            "Last Billing End Date should be within 1 year from Last Billing Start Date",
            function (lastBillingEndDate) {
              const { lastBillingStartDate } = this.parent;
              if (lastBillingStartDate && lastBillingEndDate) {
                const diffDays = differenceInDays(
                  new Date(lastBillingStartDate),
                  new Date(lastBillingEndDate)
                );
                return diffDays <= 365; // 1 year range
              }
              return true;
            }
          )
      : Yup.string().nullable(),
  });
